//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { openDB } from "idb";
import axios from "axios";
import moment from "moment";
import { mapActions, mapMutations } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    showSnackbar: false,
    snackbarMessage: "",
    snackbarColor: "error",
    showBusyAni: false,
    dlgInfo: false,
    dlgMessage: "",

    wizCurrentPage: 1,
    wizMaxPages: 9,
    wizBtnNextCaption: "Next",
    wizBtnPreviousDisabled: true,
    tno: null,
    fdata: {},
    appUserId: "",
    trialNumbers: [],
    db: null,
    prd_AirwaysManagementOnArrivalText_disabled: true,
    prd_AirwaysManagementMethod1Text_disabled: true,
    prd_WasAttemptSuccessful1_disabled: true,

    prd_AirwaysManagementMethod2Text_disabled: true,
    prd_WasAttemptSuccessful2_disabled: true,

    prd_AirwaysManagementMethod3Text_disabled: true,
    prd_WasAttemptSuccessful3_disabled: true,

    prd_AirwaysManagementMethod4Text_disabled: true,
    prd_WasAttemptSuccessful4_disabled: true,

    prd_AirwaysManagementMethod5Text_disabled: true,
    prd_WasAttemptSuccessful5_disabled: true,

    prd_AirwaysManagementMethod6Text_disabled: true,
    prd_WasAttemptSuccessful6_disabled: true,

    prd_AirwaysManagementMethod2_disabled: true,
    prd_AirwaysManagementMethod3_disabled: true,
    prd_AirwaysManagementMethod4_disabled: true,
    prd_AirwaysManagementMethod5_disabled: true,
    prd_AirwaysManagementMethod6_disabled: true,

    prd_RegurgitatedAAMused_disabled: true,
    prd_StomachContentSeenPharynx_disabled: true,
    prd_StomachContentSeenVocalCords_disabled: true,

    prd_RegurgitatedBeforeAAM_disabled: true,
    prd_RegurgitatedDuringAAM_disabled: true,
    prd_RegurgitatedAfterAAM_disabled: true,

    prd_AirwayManagementUsedRosc_disabled: true,
    prd_AirwayManagementUsedRoscText_disabled: true,
    prd_PlaceOfCarePostCardiacArrest_disabled: true,
    prd_PlaceOfCarePostCardiacArrestText_disabled: true,

    tbPostRandCRF: {
      tno: null,
      prd_CardiacArrestRhythm: null,
      prd_AirwaysManagementOnArrival: null,
      prd_AirwaysManagementOnArrivalText: "",
      prd_VentilationOccurring: null,
      prd_AirwaysManagementMethod1: null,
      prd_AirwaysManagementMethod1Text: "",
      prd_WasAttemptSuccessful1: null,
      prd_AirwaysManagementMethod2: null,
      prd_AirwaysManagementMethod2Text: "",
      prd_WasAttemptSuccessful2: null,
      prd_AirwaysManagementMethod3: null,
      prd_AirwaysManagementMethod3Text: "",
      prd_WasAttemptSuccessful3: null,
      prd_AirwaysManagementMethod4: null,
      prd_AirwaysManagementMethod4Text: "",
      prd_WasAttemptSuccessful4: null,
      prd_AirwaysManagementMethod5: null,
      prd_AirwaysManagementMethod5Text: "",
      prd_WasAttemptSuccessful5: null,
      prd_AirwaysManagementMethod6: null,
      prd_AirwaysManagementMethod6Text: "",
      prd_WasAttemptSuccessful6: null,
      prd_Regurgitated: null,
      prd_RegurgitatedAAMused: null,
      prd_RegurgitatedBeforeAAM: null,
      prd_RegurgitatedDuringAAM: null,
      prd_RegurgitatedAfterAAM: null,
      prd_StomachContentSeenPharynx: null,
      prd_StomachContentSeenVocalCords: null,
      prd_DidPatientAchieveRosc: null,
      prd_WasCardiacArrestWitnessed: null,
      prd_AirwayManagementUsedRosc: null,
      prd_AirwayManagementUsedRoscText: "",
      prd_DidPatientSurvivedTheCardiacArrest: null,
      prd_PlaceOfCarePostCardiacArrest: null,
      prd_PlaceOfCarePostCardiacArrestText: "",
      prd_DateFormCompleted: null,
    },

    tbCodeBool: [
      { value: 1, text: "No" },
      { value: 2, text: "Yes" },
    ],
    tbCodeCardiacArrestRhythm: [
      { value: 1, text: "Asystole" },
      { value: 2, text: "Ventricular Fibrillation" },
      { value: 3, text: "Pulseless Ventricular Tachycardia" },
      { value: 4, text: "Pulseless Electrical Activity" },
      { value: 5, text: "Unknown/not recorded" },
    ],
    tbCodeAirwaysManagementOnArrival: [
      { value: 1, text: "None" },
      { value: 2, text: "Mouth to mouth or mouth to mask" },
      { value: 3, text: "Bag mask ventilation" },
      { value: 4, text: "Supraglottic airway device" },
      { value: 5, text: "Tracheal Tube" },
      { value: 97, text: "Other" },
    ],
    tbCodeAirwaysManagementMethod: [
      { value: 1, text: "Bag mask ventilation" },
      { value: 2, text: "Supraglottic airway device" },
      { value: 3, text: "Tracheal Tube" },
      { value: 97, text: "Other" },
    ],
    tbCodePlaceOfCarePostCardiacArrest: [
      { value: 1, text: "ITU/HDU" },
      { value: 2, text: "General ward" },
      { value: 3, text: "Theatre" },
      { value: 4, text: "Cath lab" },
      { value: 97, text: "Other" },
    ],
  }),
  watch: {
    fdata: {
      //skip logic
      handler: function (ndata) {
        if (ndata.prd_AirwaysManagementOnArrival == 97) {
          this.prd_AirwaysManagementOnArrivalText_disabled = false;
        } else {
          this.fdata.prd_AirwaysManagementOnArrivalText = null;
          this.prd_AirwaysManagementOnArrivalText_disabled = true;
        }

        //AIRWAY MANAGEMENT ATTEMPT ONE
        if (ndata.prd_AirwaysManagementMethod1 == 97) {
          this.prd_AirwaysManagementMethod1Text_disabled = false;
        } else {
          this.fdata.prd_AirwaysManagementMethod1Text = null;
          this.prd_AirwaysManagementMethod1Text_disabled = true;
        }

        if (ndata.prd_AirwaysManagementMethod1) {
          this.prd_WasAttemptSuccessful1_disabled = false;
        } else {
          this.fdata.prd_WasAttemptSuccessful1 = null;
          this.prd_WasAttemptSuccessful1_disabled = true;
        }

        if (ndata.prd_WasAttemptSuccessful1 == 1) {
          this.prd_AirwaysManagementMethod2_disabled = false;
        } else {
          this.fdata.prd_AirwaysManagementMethod2 = null;
          this.prd_AirwaysManagementMethod2_disabled = true;
        }
        //AIRWAY MANAGEMENT ATTEMPT TWO
        if (ndata.prd_AirwaysManagementMethod2 == 97) {
          this.prd_AirwaysManagementMethod2Text_disabled = false;
        } else {
          this.fdata.prd_AirwaysManagementMethod2Text = null;
          this.prd_AirwaysManagementMethod2Text_disabled = true;
        }

        if (ndata.prd_AirwaysManagementMethod2) {
          this.prd_WasAttemptSuccessful2_disabled = false;
        } else {
          this.fdata.prd_WasAttemptSuccessful2 = null;
          this.prd_WasAttemptSuccessful2_disabled = true;
        }

        if (ndata.prd_WasAttemptSuccessful2 == 1) {
          this.prd_AirwaysManagementMethod3_disabled = false;
        } else {
          this.fdata.prd_AirwaysManagementMethod3 = null;
          this.prd_AirwaysManagementMethod3_disabled = true;
        }
        //AIRWAY MANAGEMENT ATTEMPT THREE
        if (ndata.prd_AirwaysManagementMethod3 == 97) {
          this.prd_AirwaysManagementMethod3Text_disabled = false;
        } else {
          this.fdata.prd_AirwaysManagementMethod3Text = null;
          this.prd_AirwaysManagementMethod3Text_disabled = true;
        }

        if (ndata.prd_AirwaysManagementMethod3) {
          this.prd_WasAttemptSuccessful3_disabled = false;
        } else {
          this.fdata.prd_WasAttemptSuccessful3 = null;
          this.prd_WasAttemptSuccessful3_disabled = true;
        }

        if (ndata.prd_WasAttemptSuccessful3 == 1) {
          this.prd_AirwaysManagementMethod4_disabled = false;
        } else {
          this.fdata.prd_AirwaysManagementMethod4 = null;
          this.prd_AirwaysManagementMethod4_disabled = true;
        }

        //AIRWAY MANAGEMENT ATTEMPT FOUR
        if (ndata.prd_AirwaysManagementMethod4 == 97) {
          this.prd_AirwaysManagementMethod4Text_disabled = false;
        } else {
          this.fdata.prd_AirwaysManagementMethod4Text = null;
          this.prd_AirwaysManagementMethod4Text_disabled = true;
        }

        if (ndata.prd_AirwaysManagementMethod4) {
          this.prd_WasAttemptSuccessful4_disabled = false;
        } else {
          this.fdata.prd_WasAttemptSuccessful4 = null;
          this.prd_WasAttemptSuccessful4_disabled = true;
        }

        if (ndata.prd_WasAttemptSuccessful4 == 1) {
          this.prd_AirwaysManagementMethod5_disabled = false;
        } else {
          this.fdata.prd_AirwaysManagementMethod5 = null;
          this.prd_AirwaysManagementMethod5_disabled = true;
        }
        //AIRWAY MANAGEMENT ATTEMPT FIVE
        if (ndata.prd_AirwaysManagementMethod5 == 97) {
          this.prd_AirwaysManagementMethod5Text_disabled = false;
        } else {
          this.fdata.prd_AirwaysManagementMethod5Text = null;
          this.prd_AirwaysManagementMethod5Text_disabled = true;
        }

        if (ndata.prd_AirwaysManagementMethod5) {
          this.prd_WasAttemptSuccessful5_disabled = false;
        } else {
          this.fdata.prd_WasAttemptSuccessful5 = null;
          this.prd_WasAttemptSuccessful5_disabled = true;
        }

        if (ndata.prd_WasAttemptSuccessful5 == 1) {
          this.prd_AirwaysManagementMethod6_disabled = false;
        } else {
          this.fdata.prd_AirwaysManagementMethod6 = null;
          this.prd_AirwaysManagementMethod6_disabled = true;
        }
        //AIRWAY MANAGEMENT ATTEMPT SIX
        if (ndata.prd_AirwaysManagementMethod6 == 97) {
          this.prd_AirwaysManagementMethod6Text_disabled = false;
        } else {
          this.fdata.prd_AirwaysManagementMethod6Text = null;
          this.prd_AirwaysManagementMethod6Text_disabled = true;
        }

        if (ndata.prd_AirwaysManagementMethod6) {
          this.prd_WasAttemptSuccessful6_disabled = false;
        } else {
          this.fdata.prd_WasAttemptSuccessful6 = null;
          this.prd_WasAttemptSuccessful6_disabled = true;
        }

        //SECTION THREE – REGURGITATION
        if (ndata.prd_Regurgitated == 2) {
          this.prd_RegurgitatedAAMused_disabled = false;
          this.prd_StomachContentSeenPharynx_disabled = false;
          this.prd_StomachContentSeenVocalCords_disabled = false;
        } else {
          this.fdata.prd_RegurgitatedAAMused = null;
          this.fdata.prd_StomachContentSeenPharynx = null;
          this.fdata.prd_StomachContentSeenVocalCords = null;
          this.prd_RegurgitatedAAMused_disabled = true;
          this.prd_StomachContentSeenPharynx_disabled = true;
          this.prd_StomachContentSeenVocalCords_disabled = true;
        }

        if (ndata.prd_RegurgitatedAAMused == 2) {
          this.prd_RegurgitatedBeforeAAM_disabled = false;
          this.prd_RegurgitatedDuringAAM_disabled = false;
          this.prd_RegurgitatedAfterAAM_disabled = false;
        } else {
          this.fdata.prd_RegurgitatedBeforeAAM = null;
          this.fdata.prd_RegurgitatedDuringAAM = null;
          this.fdata.prd_RegurgitatedAfterAAM = null;
          this.prd_RegurgitatedBeforeAAM_disabled = true;
          this.prd_RegurgitatedDuringAAM_disabled = true;
          this.prd_RegurgitatedAfterAAM_disabled = true;
        }
        //SECTION FOUR – CARDIAC ARREST OUTCOME
        if (ndata.prd_DidPatientAchieveRosc == 2) {
          this.prd_AirwayManagementUsedRosc_disabled = false;
        } else {
          this.fdata.prd_AirwayManagementUsedRosc = null;
          this.prd_AirwayManagementUsedRosc_disabled = true;
        }

        if (ndata.prd_AirwayManagementUsedRosc == 97) {
          this.prd_AirwayManagementUsedRoscText_disabled = false;
        } else {
          this.fdata.prd_AirwayManagementUsedRoscText = null;
          this.prd_AirwayManagementUsedRoscText_disabled = true;
        }

        if (ndata.prd_DidPatientSurvivedTheCardiacArrest == 2) {
          this.prd_PlaceOfCarePostCardiacArrest_disabled = false;
        } else {
          this.fdata.prd_PlaceOfCarePostCardiacArrest = null;
          this.prd_PlaceOfCarePostCardiacArrest_disabled = true;
        }

        if (ndata.prd_PlaceOfCarePostCardiacArrest == 97) {
          this.prd_PlaceOfCarePostCardiacArrestText_disabled = false;
        } else {
          this.fdata.prd_PlaceOfCarePostCardiacArrestText = null;
          this.prd_PlaceOfCarePostCardiacArrestText_disabled = true;
        }
      },
      deep: true,
    },
    tno: async function (nval) {
      if (!nval) {
        Object.assign(this.fdata, this.tbPostRandCRF);
        this.setCrfTitle(null);
        return;
      }
      this.setCrfTitle(`TNO: ${nval}`);
      const sdata =
        (await this.db
          .transaction("tbPostRandCRF")
          .objectStore("tbPostRandCRF")
          .get(nval)) || this.tbPostRandCRF;

      Object.assign(this.fdata, sdata);
    },
    wizCurrentPage: function (nval) {
      if (nval > 1) {
        this.wizBtnPreviousDisabled = false;
      } else {
        this.wizBtnPreviousDisabled = true;
      }
      if (nval == 9) {
        this.wizBtnNextCaption = "Submit";
      } else {
        this.wizBtnNextCaption = "Next";
      }
      this.$vuetify.goTo(".app-container");
    },
  },
  computed: {},
  methods: {
    ...mapMutations(["setCrfTitle", "setAppBusyAnimation"]),
    ...mapActions([
      "fetchAppUserId",
      "clientIsOffline",
      "fetchAllOfflineRandomisations",
      "fetchRandomisationCount",
      "clearAllOfflineRandomisations",
      "saveOfflineRandomisation",
    ]),
    async nextPage() {
      //validate
      const stepIsInvalid =
        (this.wizCurrentPage == 1 && !(await this.$refs.frmStep1.validate())) ||
        (this.wizCurrentPage == 2 && !(await this.$refs.frmStep2.validate())) ||
        (this.wizCurrentPage == 3 && !(await this.$refs.frmStep3.validate())) ||
        (this.wizCurrentPage == 4 && !(await this.$refs.frmStep4.validate())) ||
        (this.wizCurrentPage == 5 && !(await this.$refs.frmStep5.validate())) ||
        (this.wizCurrentPage == 6 && !(await this.$refs.frmStep6.validate())) ||
        (this.wizCurrentPage == 7 && !(await this.$refs.frmStep7.validate())) ||
        (this.wizCurrentPage == 8 && !(await this.$refs.frmStep8.validate())) ||
        (this.wizCurrentPage == 9 && !(await this.$refs.frmStep9.validate()));
      if (stepIsInvalid) {
        this.snackbarColor = "error";
        this.snackbarMessage = "Form contains validation warning(s).";
        this.showSnackbar = true;
        return;
      }
      //save data locally
      if (this.wizCurrentPage == 9) {
        this.fdata.tno = this.tno;
        this.fdata.prd_DateFormCompleted = moment().format(
          "YYYY-MM-DDTHH:mm:ss"
        );
        //reset latestRandResult
        await this.db
          .transaction("tbSettings", "readwrite")
          .objectStore("tbSettings")
          .put(null, "latestRandResult");
      }

      await this.db
        .transaction("tbPostRandCRF", "readwrite")
        .objectStore("tbPostRandCRF")
        .put(this.fdata, this.tno);

      if (this.wizCurrentPage == 9) {
        this.showBusyAni = true;
        if (!(await this.clientIsOffline())) {
          //check and upload offline Rands if exists
          if ((await this.fetchRandomisationCount()) > 0) {
            const offlineRandsUploadStatus =
              await this.uploadOfflineRandomisations();
            if (offlineRandsUploadStatus != 0) {
              this.dlgMessage =
                "Sorry, we are having some technical issues. Please email airways3@warwick.ac.uk quoting error description: OFFLINE-RANDS-FAILED-TO-SYNC-AT-POST-RAND";
              this.dlgInfo = true;
              return;
            }
          }
          //attempt uploading PostRandCRFs
          const sdata = await this.db
            .transaction("tbPostRandCRF")
            .objectStore("tbPostRandCRF")
            .getAll();

          const pdata = sdata.filter(
            (p) => p && p.prd_DidPatientSurvivedTheCardiacArrest
          );
          if (pdata.length > 0) {
            await this.savePostRandCRFs({
              appUserId: this.appUserId,
              clientActivityType: "ONLINE(REAL-TIME)-POST-RAND-CRFs-SUBMITTED",
              postRandCRFs: pdata,
            });
          }
        } else {
          // this.tno = null;
          // this.wizCurrentPage = 1;
          // this.wizBtnNextCaption = "Next";
          // this.setCrfTitle("Post Rand CRF");

          // this.snackbarColor = "success";
          // this.snackbarMessage = "Post-Rand-CRF saved offline successfully!";
          // this.showSnackbar = true;

          this.dlgMessage = "Post-Rand-CRF saved offline successfully!";
          this.dlgInfo = true;
          // this.$router.push("/");
        }
        this.showBusyAni = false;
        return;
      }
      if (this.wizCurrentPage < this.wizMaxPages) {
        const airwaysManagementAttemptStatus =
          (this.wizCurrentPage == 2 &&
            this.fdata.prd_WasAttemptSuccessful1 == 2) ||
          (this.wizCurrentPage == 3 &&
            this.fdata.prd_WasAttemptSuccessful2 == 2) ||
          (this.wizCurrentPage == 4 &&
            this.fdata.prd_WasAttemptSuccessful3 == 2) ||
          (this.wizCurrentPage == 5 &&
            this.fdata.prd_WasAttemptSuccessful4 == 2) ||
          (this.wizCurrentPage == 6 &&
            this.fdata.prd_WasAttemptSuccessful5 == 2);

        if (airwaysManagementAttemptStatus) {
          //skip to
          this.wizCurrentPage = 8;
          return;
        }
        this.wizCurrentPage += 1;
      }
    },
    previousPage() {
      if (this.wizCurrentPage > 1) {
        if (this.wizCurrentPage == 8) {
          if (this.fdata.prd_WasAttemptSuccessful6) {
            //skip to
            this.wizCurrentPage = 2;
          } else if (this.fdata.prd_WasAttemptSuccessful5 == 2) {
            //skip to
            this.wizCurrentPage = 6;
          } else if (this.fdata.prd_WasAttemptSuccessful4 == 2) {
            //skip to
            this.wizCurrentPage = 5;
          } else if (this.fdata.prd_WasAttemptSuccessful3 == 2) {
            //skip to
            this.wizCurrentPage = 4;
          } else if (this.fdata.prd_WasAttemptSuccessful2 == 2) {
            //skip to
            this.wizCurrentPage = 3;
          } else if (this.fdata.prd_WasAttemptSuccessful1 == 2) {
            //skip to
            this.wizCurrentPage = 2;
          }
          return;
        }
        this.wizCurrentPage -= 1;
      }
    },
    async savePostRandCRFs(fdata) {
      this.showBusyAni = true;
      const actionUrl = `${process.env.BASE_URL}Randomisation/SavePostRandCRFs`;
      try {
        const {
          data: { rstatus },
        } = await axios.post(actionUrl, fdata);

        if (rstatus == 0) {
          const { postRandCRFs } = fdata;
          postRandCRFs.forEach(async (item) => {
            await this.db
              .transaction("tbPostRandCRF", "readwrite")
              .objectStore("tbPostRandCRF")
              .delete(item.tno);
          });

          //Object.assign(this.fdata, this.tbPostRandCRF);
          this.tno = null;

          this.trialNumbers = await this.db
            .transaction("tbPostRandCRF")
            .objectStore("tbPostRandCRF")
            .getAllKeys();

          if (this.trialNumbers.length == 0) {
            //no more TNOs to enter, display message and redirect to home page
            this.dlgMessage = "Post-Rand-CRFs submitted successfully!";
            this.dlgInfo = true;
          }

          this.wizCurrentPage = 1;
          this.wizBtnNextCaption = "Next";
          this.setCrfTitle("Post Rand CRF");

          this.snackbarColor = "success";
          this.snackbarMessage = "Post-Rand-CRFs submitted successfully!";
          this.showSnackbar = true;
        }
        this.showBusyAni = false;
      } catch (error) {
        this.showBusyAni = false;

        this.dlgMessage =
          "Sorry, we are having some technical issues. Please email airways3@warwick.ac.uk quoting error description: POST-RAND-CRFs-FAILED-TO-UPLOAAD";
        this.dlgInfo = true;

        throw error;
      }
    },
    async uploadOfflineRandomisations() {
      this.offlineRands = await this.fetchAllOfflineRandomisations();
      const fdata = {
        appUserId: this.appUserId,
        clientActivityType: "ONLINE(REAL-TIME)-POST-RAND-CRF-SUBMITTED",
        offlineRands: this.offlineRands,
      };
      this.showBusyAni = true;
      const actionUrl = `${process.env.BASE_URL}Randomisation/SyncOfflineRandomisations`;
      try {
        const {
          data: { rstatus, activeSites },
        } = await axios.post(actionUrl, fdata);

        if (rstatus == 0) {
          const db = await openDB("AIRWAYS3idb");
          await db
            .transaction("tbSettings", "readwrite")
            .objectStore("tbSettings")
            .put(activeSites, "sites");

          await this.clearAllOfflineRandomisations();
          return 0;
        }
        this.showBusyAni = false;
        return -1;
      } catch (error) {
        this.showBusyAni = false;
        throw error;
      }
    },
    onOKClickedDlgInfo() {
      this.$router.push("/");
    },
  },
  async mounted() {
    this.setCrfTitle("Post Rand CRF");
    this.fdata = Object.assign({}, this.tbPostRandCRF);
    this.appUserId = await this.fetchAppUserId();

    const db = await openDB("AIRWAYS3idb");
    this.trialNumbers = await db
      .transaction("tbPostRandCRF")
      .objectStore("tbPostRandCRF")
      .getAllKeys();

    this.db = db;

    this.setAppBusyAnimation(false);
  },
};
